import { render } from "./RakutenHomeHotSeriesCloth.vue?vue&type=template&id=030023b8"
import script from "./RakutenHomeHotSeriesCloth.vue?vue&type=script&lang=js"
export * from "./RakutenHomeHotSeriesCloth.vue?vue&type=script&lang=js"

import exportComponent from "F:\\admin_om\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__